import { baseRequestBackendTs } from './baseRequest';

/* -------------------- Read endpoints -------------------- */

export const listGymOrders = (params) => {
    const url = '/gym/ops/orders';
    return baseRequestBackendTs(url, 'GET', params, null);
};

export const getGymOrderDetails = (groupKey) => {
    const url = `/gym/ops/orders/${encodeURIComponent(groupKey)}/details`;
    return baseRequestBackendTs(url, 'GET', null, null);
};

export const getGymOrderBookings = (groupKey) => {
    const url = `/gym/ops/orders/${encodeURIComponent(groupKey)}/bookings`;
    return baseRequestBackendTs(url, 'GET', null, null);
};

export const getGymHealthIssues = (params) => {
    const url = '/gym/ops/health-issues';
    return baseRequestBackendTs(url, 'GET', params, null);
};

export const listGymSponsors = (partner = 'fitpass') => {
    const url = '/gym/ops/sponsors';
    return baseRequestBackendTs(url, 'GET', { partner }, null);
};

export const listGymPlans = () => {
    const url = '/gym/ops/plans';
    return baseRequestBackendTs(url, 'GET', null, null);
};

/* -------------------- Action endpoints -------------------- */

export const retryGymPartnerRegister = (enrolmentId, reason) => {
    const url = `/gym/ops/enrolments/${enrolmentId}/retry-partner-register`;
    return baseRequestBackendTs(url, 'POST', null, { reason });
};

export const gymManualRefund = (enrolmentId, { reason, refundPgAmount }) => {
    const url = `/gym/ops/enrolments/${enrolmentId}/manual-refund`;
    return baseRequestBackendTs(url, 'POST', null, { reason, refundPgAmount });
};

export const gymStatusOverride = (enrolmentId, { newStatus, reason }) => {
    const url = `/gym/ops/enrolments/${enrolmentId}/status-override`;
    return baseRequestBackendTs(url, 'POST', null, { newStatus, reason });
};

export const gymReplayOnboarding = (enrolmentId, reason) => {
    const url = `/gym/ops/enrolments/${enrolmentId}/replay-onboarding`;
    return baseRequestBackendTs(url, 'POST', null, { reason });
};

export const gymBackfillDpu = (enrolmentId, reason) => {
    const url = `/gym/ops/enrolments/${enrolmentId}/backfill-dpu`;
    return baseRequestBackendTs(url, 'POST', null, { reason });
};

export const gymAdminOnboard = (payload) => {
    const url = '/gym/ops/admin-onboard';
    return baseRequestBackendTs(url, 'POST', null, payload);
};
